<template>
    <main-layout>

        <!-- Wrapper avec dégradé bleu -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="factory" class="text-white pt-4 px-4">
                <h1 class="text-2xl flex items-center gap-3">
                    <span>Installation</span>
                </h1>
            </app-header>

            <!-- Action bar (Retour + action état) -->
            <action-bar :back="{ name: 'liste-installations' }" class="px-4 pb-6">
                <!-- Bouton à droite (garde la navigation existante) -->
                <router-link v-if="typeUser === 'technicien'"
                    class="bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium text-right"
                    id="install_intervenant_btn"
                    :to="{ name: 'new-fibsdd', query: { detenteur: $route.params.id, installation: $route.params.idInst } }">
                    <strong>Intervenir</strong><br>sur l'installation
                </router-link>
            </action-bar>
        </div>

        <!-- Contenu principal : fond dégradé + arrondi comme Vite -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">

            <!-- “Carte” blanche principale -->
            <div class="m-2 shadow-2xl rounded-lg overflow-hidden mb-30">
                <div class="bg-white p-4">

                    <!-- Lien infos complémentaires (couleur selon fluide) -->
                    <div class="mb-4" v-if="installation.i_tag !== null || optionForceOtag === true">
                        <router-link :to="{ name: 'information-installation' }"
                            class="px-3 py-2 text-white rounded-xl flex items-center justify-between shadow-lg"
                            :class="installation.fluide !== null ? 'bg-otag-install' : 'bg-otag-install'">
                            <h2 class="text-sm font-semibold uppercase">
                                Informations complémentaires
                                <template v-if="installation.fluide !== null">
                                    (DESP, Maintenance préventive, Attestation Entretien)
                                </template>
                                <template v-else>
                                    (Maintenance préventive)
                                </template>
                            </h2>
                            <i class="inline-block h-8 w-8 mask mask-info bg-white opacity-50"></i>
                        </router-link>
                    </div>

                    <!-- Carte / Map -->
                    <div id="map" ref="map" class="hidden" style="height: 210px; width: 100%; margin-bottom: 10px">
                    </div>

                    <!-- FORM -->
                    <form method="post" id="installation" @submit.prevent="sendForm" class="space-y-4">
                        <!-- OTAG INSTALL bloc -->
                        <div v-if="installation.i_tag !== null">
                            <label class="label m-0">OTAG INSTALL</label>

                            <div class="flex items-center gap-2">
                                <input title="installItag" type="text" name="itag" v-model.trim="installation.i_tag"
                                    maxlength="255" readonly class="input flex-1" />

                                <a id="change-itag"
                                    :href="`fi360://scan?success=tryGoToInstall&idInst=${$route.params.idInst}&idDet=${$route.params.id}`"
                                    class="input bg-otag-install text-white uppercase font-semibold inline-flex items-center justify-center !w-auto whitespace-nowrap">
                                    Changer l'otag install
                                </a>
                            </div>
                        </div>

                        <div v-else>
                            <a :href="`fi360://scan?success=tryGoToInstall&idInst=${$route.params.idInst}&idDet=${$route.params.id}`"
                                id="add-itag"
                                class="px-3 py-2 bg-otag-install text-white rounded-xl flex items-center justify-between shadow-lg">
                                <h2 class="text-md font-semibold uppercase">Ajouter une Otag install</h2>
                                <i class="inline-block h-12 w-12 mask mask-otag-install bg-white opacity-50"></i>
                            </a>
                        </div>

                        <!-- Nom + barcode -->
                        <div>
                            <label for="nom" class="label">Nom de l'installation <span class="text-alert">*</span></label>
                            <div class="flex">
                                <input title="installName" type="text" name="nom" id="nom" maxlength="255"
                                    v-model.trim="installation.nom" class="input flex-1" />
                                <a v-if="optionBarcode === true"
                                    href="fi360://scan?success=fillCodeBarre&type=installation" id="barcode-scan"
                                    class="bg-secondary text-white p-1 ml-2 rounded flex items-center justify-center">
                                    <i class="h-8 w-8 mask mask-scan-barcode bg-white"></i>
                                </a>
                            </div>
                        </div>

                        <!-- Marque / Modèle -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="label" for="marque">Marque <span class="text-alert" v-if="!gotFluide">*</span></label>
                                <input title="marque" type="text" id="marque" maxlength="255"
                                    v-model.trim="installation.marque" class="input" />
                            </div>
                            <div>
                                <label class="label" for="modele">Modèle / N° de série / Repère <span class="text-alert"
                                        v-if="!gotFluide">*</span></label>
                                <input title="model" type="text" id="modele" maxlength="255"
                                    v-model.trim="installation.modele" class="input" />
                            </div>
                        </div>

                        <!-- Photo installation -->
                        <div class="mb-4">
                            <div class="px-3 py-2 bg-primary text-white rounded-xl flex items-center justify-between shadow-lg cursor-pointer"
                                id="install_btn_photo" @click="$refs.photoInstall.click()">
                                <h2 class="text-md font-semibold uppercase">
                                    PHOTO INSTALLATION OU PLAQUE SIGNALETIQUE
                                </h2>
                                <i class="inline-block h-8 w-8 mask mask-photo bg-white opacity-50"></i>
                            </div>
                            <input type="file" ref="photoInstall" v-show="false" @change="handlePhotoInstall"
                                accept="image/*" />
                            <div class="mt-4 flex justify-center" v-show="urlPhoto !== null">
                                <div class="relative">
                                    <i class="icon icon-delete absolute -top-2 -right-2 cursor-pointer"
                                        @click="installation.photo = null"></i>
                                    <a :href="urlPhoto" target="_blank">
                                        <img :src="urlPhoto" alt="photo installation" id="photo-install"
                                            class="max-h-64 rounded shadow" />
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Zone fluide -->
                        <div v-if="gotFluide" class="space-y-4">
                            <div>
                                <label class="label">Type de fluide <span class="text-alert">*</span></label>
                                <select v-if="installation.fluide" v-model="installation.fluide"
                                    @change="updateComputed" class="input">
                                    <option selected disabled>Sélectionnez un fluide</option>
                                    <option v-for="fluide in fluides" :key="fluide.id" :value="fluide">
                                        {{ fluide.nom }}{{ fluide.nom_commercial ? ' - ' + fluide.nom_commercial : '' }}
                                    </option>
                                </select>
                            </div>

                            <div>
                                <label class="label" for="charge_totale">Charge totale (Kg) <span class="text-alert">*</span></label>
                                <input title="chargeTotal" type="number" name="charge_totale" min="0.010" step="0.001"
                                    id="charge_totale" v-model.number="installation.charge" @change="updateComputed"
                                    class="input" />
                            </div>

                            <!-- Détecteur de fuite -->
                            <div>
                                <p class="label">Détecteur de fuite fixe <span class="text-alert">*</span></p>
                                <div class="flex items-center space-x-4 mt-3">
                                    <label class="inline-flex items-center gap-2">
                                        <input name="detecteur_fuite_fixe" type="radio" :value="true"
                                            v-model="installation.detecteur" @change="updateComputed"
                                            class="hidden peer" id="fuite_ok" />
                                        <span for="fuite_ok"
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">Oui</span>
                                    </label>

                                    <label class="inline-flex items-center gap-2">
                                        <input name="detecteur_fuite_fixe" type="radio" :value="false"
                                            v-model="installation.detecteur" @change="updateComputed"
                                            class="hidden peer" id="fuite_ko" />
                                        <span for="fuite_ko"
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">Non</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Forçage fréquence -->
                            <div v-if="canForceFrequence === true">
                                <p class="label">Fréquence de contrôle forcée</p>
                                <div class="flex items-center space-x-4 mt-3">
                                    <label class="inline-flex items-center gap-2">
                                        <input name="force_frequence" type="radio" :value="true"
                                            v-model="installation.force_frequence" @change="updateComputed"
                                            class="hidden peer" id="force_frequence" />
                                        <span
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">Oui</span>
                                    </label>

                                    <label class="inline-flex items-center gap-2">
                                        <input name="force_frequence" type="radio" :value="false"
                                            v-model="installation.force_frequence" @change="updateComputed"
                                            class="hidden peer" id="force_frequence_no" />
                                        <span
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">Non</span>
                                    </label>
                                </div>

                                <div v-if="installation.force_frequence === true" class="my-4">
                                    <label class="label" for="frequence_controle">Fréquence de contrôle</label>
                                    <select name="frequence_controle" id="frequence_controle"
                                        v-model="installation.frequence_controle" class="input">
                                        <option value="3">3 mois</option>
                                        <option value="6">6 mois</option>
                                        <option value="12">12 mois</option>
                                        <option value="24">24 mois</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Infos calculées -->
                            <div v-show="fluideIsFibsdd" class="space-y-1 leading-tight">
                                <p v-if="installation.fluide !== null && installation.fluide.type !== 'HFO'"
                                    class="!my-0">
                                    Tonnage équivalent CO<span class="smallexp">2</span> :
                                    <span id="tonnage" class="text-secondary font-bold"
                                        v-text="installation.tonnage"></span>
                                </p>

                                <p class="!my-0">
                                    GWP :
                                    <span id="gwp" class="text-secondary font-bold"
                                        v-text="installation.fluide.gwp"></span>
                                </p>

                                <p v-if="installation.fluide && installation.fluide.type !== 'CFC'" class="!my-0">
                                    Fréquence de contrôle
                                    <span v-if="installation.force_frequence === true" class="font-bold">forcée</span>
                                    de l'installation :
                                    <span id="frequence" class="text-secondary font-bold">
                                        {{ installation.frequence_controle === 0 || installation.frequence_controle ==
                                            null ? 'Aucune' :
                                        installation.frequence_controle + ' Mois' }}
                                    </span>
                                </p>

                                <p v-if="installation.file_notice && installation.file_notice !== null"
                                    id="install_notice_block" class="!my-0">
                                    <a :href="getUrlNotice" target="_blank"
                                        class="px-3 py-2 bg-primary text-white rounded-xl inline-flex items-center gap-2 shadow-lg"
                                        id="install_notice_link">
                                        <i class="inline-block h-6 w-6 mask mask-file bg-white opacity-50"></i>
                                        <span>Notice de l'installation</span>
                                    </a>
                                </p>

                                <p v-if="installation.last_control != null" class="!my-0">
                                    Date du dernier contrôle périodique :
                                    <span id="dateLastControl" class="text-secondary font-bold">
                                        {{ installation.last_control | dateFormat('DD/MM/YYYY') }}
                                    </span>
                                </p>
                            </div>

                        </div>

                        <!-- Submit -->
                        <input type="submit" id="submit-install" name="new" v-if="canEditInstallations"
                            value="SAUVEGARDER" class="btn-primary" />
                    </form>

                    <!-- Registre des interventions (style tableau comme ton exemple) -->
                    <div v-if="fis.length !== 0" class="mt-6 bg-gris-bleu rounded-lg shadow overflow-hidden mb-25">
                        <h3 class="text-xl text-primary font-normal p-3">REGISTRE DES INTERVENTIONS</h3>
                        <table class="w-full border-collapse bg-white">
                            <tbody>
                            <tr v-for="fi in fis.slice().reverse()" :key="fi.id" class="border-y border-gray-200 odd:bg-[#F7F9FC]">
                                <td>
                                    <div class="p-3 text-left flex items-center space-x-4">
                                        <!-- Date -->
                                        <p class="text-md">{{ fi.dateToShow }}</p>
                                        <!-- Numéro ou nom : lien selon le type -->
                                        <a
                                            :href="fi.isFibsdd === true ? `${Config.urlAdmin}/pdf/fiche/${fi.id}?token=${token}` : `${Config.urlAdmin}/pdf/externalFile/${fi.id}?token=${token}`"
                                            target="_blank"
                                            class="text-md font-bold text-secondary"
                                        >
                                            {{ fi.isFibsdd === true ? fi.numero : fi.name }}
                                        </a>
                                        <!-- Libellé contrôle périodique -->
                                        <p v-if="fi.isFibsdd === true && fi.intervention_controle_p === true" class="text-md italic text-gray-500">
                                            Contrôle périodique
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>

        </main>
    </main-layout>
</template>

<script>
import Api from '../../js/core/Api';
import Installation from '../../js/models/Installation'
import Offline from '../../js/models/Offline'
import Config from '../../js/config'

import loadImage from 'blueimp-load-image'
import Operateur from "../../js/models/Operateur";
import Scan from "../../js/models/Scan";
import informationInstallation from "./InformationInstallation.vue";
import { install } from "offline-plugin/runtime";

export default {
    data() {
        return {
            typeUser: localStorage.getItem('typeUser'),
            installation: {
            },
            fluides: null,
            canEditInstallations: null,
            fis: [],
            token: null,
            urlNotice: null,
            canForceFrequence: false,
            optionBarcode: false,
            optionForceOtag: false
        }
    },

    computed: {
        Config() {
            return Config
        },

        gotFluide() {
            return (!_.isEmpty(this.installation.fluide));
        },

        getUrlNotice() {
            if (this.installation.file_notice != null) {
                return `${Config.urlAdmin}/pdf/installation/notice/${this.installation.id}?token=${this.token}`;
            }
            return null;
        },

        urlPhoto() {
            if (this.installation.photo === null || typeof this.installation.photo == "undefined") { return null }
            const http = Config.urlAPI + '/upload';
            return _.includes(this.installation.photo, ';base64') ? this.installation.photo : http + this.installation.photo;

        },

        fluideIsFibsdd() {
            if (!_.isEmpty(this.installation.fluide)) {
                const typeFluide = this.installation.fluide.type;
                return (
                    typeFluide === 'HFC' ||
                    typeFluide === 'HCFC' ||
                    typeFluide === 'CFC' ||
                    typeFluide === 'Mélange HFO/HFC' ||
                    typeFluide === 'HFO'
                );
            } else {
                return false
            }
        }
    },

    methods: {
        install,

        sendForm() {

            let installation = this.installation;
            let errors = [];

            // CONDITION COMMUNE
            if (!installation.nom) {
                errors.push("le nom de l'installation")
            }

            if (_.isEmpty(installation.fluide)) {

                if (!installation.marque) {
                    errors.push("la marque")
                }
                if (!installation.modele) {
                    errors.push("le modèle")
                }

            } else {

                if (_.isEmpty(installation.fluide)) {
                    errors.push("le fluide")
                }
                if (!installation.charge) {
                    errors.push("la charge")
                }
                if (installation.detecteur === null) {
                    errors.push("le détecteur")
                }

            }

            if (errors.length !== 0) {

                let txt = errors.join(', ');
                swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')

            } else {

                Installation
                    .getList()
                    .then(list => {

                        let indexToSwap = _.findIndex(list, ['id', this.installation.id]);
                        list[indexToSwap] = this.installation;


                        if (this.$route.query.itag != null) {
                            Scan.addOfflineScanInstallation(this.installation.id);
                        }

                        localforage
                            .setItem('listInstallations', JSON.stringify(list))
                            .then(() => {
                                Offline.saveAction({
                                    action: 'update',
                                    type: 'Installation',
                                    id: this.installation.id
                                });

                                this.$router.push({ name: 'liste-installations', params: { id: this.$route.params.id } })

                            })
                            .catch()

                    })

            }

        },

        handlePhotoInstall(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.installation.photo = img.toDataURL();
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )
        },

        fetchFluides() {
            let vueInstance = this;

            localforage.getItem('listFluides')
                .then(fluides => {
                    fluides = JSON.parse(fluides);
                    vueInstance.fluides = fluides.noFiltre.filter(f => !f.regenerated);
                })
                .catch()
        },

        fetchInstall() {

            return new Promise((resolve, reject) => {
                let vueInstance = this;
                let idInstall = this.$route.params.idInst;
                let itag = this.$route.query.itag;

                Installation
                    .getInstallation(idInstall)
                    .then(res => {
                        vueInstance.installation = res;
                        if(res.fluide !== null) {
                            res.charge = round(res.charge, 3);
                            res.tonnage = round(res.fluide.gwp * res.charge / 1000, 3);
                        }
                        if (typeof itag !== "undefined") {
                            vueInstance.installation.i_tag = itag;
                        }
                        return resolve(true)
                    })
                    .catch(() => {
                        reject(false)
                    })
            })


        },

        async fetchFis() {
            let api = await Api.init();
            api
                .get(`installation/${this.installation.id}/fibsdds/1`)
                .then(res => {
                    if (typeof res.data.fis !== "undefined") {
                        res.data.fis.forEach(data => {
                            if (data.isFibsdd) {
                                data.dateToShow = data.dateToShow || "En cours";
                            }
                            this.fis.push(data);
                        });
                    }
                }).then(() => {
                this.fis = _.sortBy(this.fis, f => {
                    return new Date(f.dateToShow.split('/').reverse().join('-'));
                })
            })
                .catch()

        },


        updateComputed() {

            if (_.has(this.installation.fluide, 'gwp') && this.installation.charge != null) {

                this.updateTonnage();

                if (this.installation.detecteur !== null && this.installation.force_frequence !== true) {
                    this.updateFrequence()
                }

            }

        },

        updateTonnage() {
            this.installation.tonnage = round(this.installation.fluide.gwp * this.installation.charge / 1000, 3);
        },

        updateFrequence() {

            let tonnage = this.installation.tonnage;
            let charge = this.installation.charge;
            let freq = 0;

            if (this.installation.fluide.type === "HFO") {

                if (charge < 1) {
                    return this.installation.frequence_controle = 0;
                }

                if (charge >= 1 && charge < 10) {
                    return this.installation.frequence_controle = this.verifyFrequence(12);
                }

                if (charge >= 10 && charge < 100) {
                    return this.installation.frequence_controle = this.verifyFrequence(6);
                }

                if (charge >= 100) {
                    return this.installation.frequence_controle = this.verifyFrequence(3)
                }

                return this.installation.frequence_controle = 6;
            }

            if (this.installation.fluide.type === 'HCFC') {
                freq = 0;
                if (charge >= 2 && charge < 30) {
                    return this.installation.frequence_controle = this.verifyFrequence(12);
                }

                if (charge >= 30 && charge < 300) {
                    return this.installation.frequence_controle = this.verifyFrequence(6);
                }

                if (charge >= 300) {
                    return this.installation.frequence_controle = this.verifyFrequence(3);
                }
            }

            if (this.installation.fluide.type !== "HFO" && this.installation.fluide.type !== "HCFC") {
                if (tonnage >= 5 && tonnage < 50) {
                    return this.installation.frequence_controle = this.verifyFrequence(12);
                }

                if (tonnage >= 50 && tonnage < 500) {
                    return this.installation.frequence_controle = this.verifyFrequence(6);
                }

                if (tonnage >= 500) {
                    return this.installation.frequence_controle = this.verifyFrequence(3);
                }
            }
        },

        verifyFrequence(freq) {
            if (this.installation.detecteur === true) {
                return freq * 2;
            }
            return freq;
        },

        displayMap() {

            if (this.installation.i_tag != null) {
                let lastScan = _.last(this.installation.scans_installations);


                if (typeof lastScan !== "undefined") {

                    let mapEl = document.getElementById('map');

                    mapEl.classList.remove('hidden');

                    let map = L.map(mapEl, { attributionControl: false, center: [lastScan.lat, lastScan.lng], zoom: 19, maxZoom: 19, zoomControl: false });
                    delete L.Icon.Default.prototype._getIconUrl;
                    L.Icon.Default.mergeOptions({
                        iconRetinaUrl: "https://admin.fi360.fr/img/marker-orange.png",
                        iconUrl: "https://admin.fi360.fr/img/marker-orange.png",
                        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
                    });

                    let layer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 19,
                    });

                    map.addLayer(layer);

                    let marker = L.marker([lastScan.lat, lastScan.lng], {
                    }).addTo(map);

                    marker.bindPopup(`<b>${this.installation.nom}</b><br>${moment(lastScan.created_at).format('DD/MM/YYYY HH:mm')}`, {
                        className: 'custom-popup'
                    })

                }
            }

        }
    },

    mounted: function () {
        this.canEditInstallations = JSON.parse(localStorage.getItem('canEditInstallations'));
        localforage.getItem('api-token').then(token => this.token = token).catch();
        this.fetchFluides();



        this.fetchInstall().then(() => {
            if (this.$route.query.scan != null) {
                Scan.addOfflineScanInstallation(this.installation.id);
            }
            this.fetchFis()
        }).then(() => {
            this.$nextTick(() => {
                this.displayMap(); // Appel de la fonction displayMap lors du montage du composant
            });
        })

        Operateur.getOperateurOption(options => {
            this.canForceFrequence = options.includes('force_install_frequence');
            this.optionBarcode = options.includes('scan_barcode_install');
            this.optionForceOtag = options.includes('force_otag_install');
        })

    },
}
</script>

<style>
@import '~leaflet/dist/leaflet.css';
</style>



// WEBPACK FOOTER //
// Installation.vue?3745a1d3